import { editRegistrationService } from 'src/modules/Distances/services';

export const loadEditRegistrationData = async (distanceId: number, callBack: Function) => {
  await editRegistrationService.load(distanceId, callBack);
};
